import React, { useEffect, useState, useRef } from "react";
import cta from "./Assets/cta3d.png";

import { Drawer, Button, Carousel, List, Spin } from "antd";

import {
  RightOutlined,
  MenuOutlined,
  CloseOutlined,
  LeftOutlined,
  EnvironmentTwoTone,
  PhoneTwoTone,
  MailTwoTone,
  WhatsAppOutlined,
} from "@ant-design/icons";

// Reveal
import AOS from "aos";
import "aos/dist/aos.css";

import "./styles.scss";
import "./button.scss";

import logo from "../../Assets/Logos/logo.png";


import heroImage from "./Assets/hero3d.png";
import { getHomeCourses } from "../../Constants/Api/functions/function";
import {
  DEFAULT_COURSE_COVER_IMAGE,
  DEFAULT_USER_PROFILE_IMAGE,
} from "../../Constants/Api/azure/azure";
import { Link } from "react-router-dom";

import image1 from "./Assets/banner1.jpg";
import image2 from "./Assets/banner2.jpg";
import image3 from "./Assets/banner3.jpg";
import image4 from "./Assets/banner4.jpg";



// AOS.init();
// AOS.init({
//   disable: false,
//   startEvent: 'DOMContentLoaded',
//   initClassName: 'aos-init',
//   animatedClassName: 'aos-animate',
//   useClassNames: false,
//   disableMutationObserver: false,
//   debounceDelay: 50,
//   throttleDelay: 99,

//   offset: 120,
//   delay: 0,
//   duration: 500,
//   easing: 'ease',
//   once: false,
//   mirror: false,
//   anchorPlacement: 'top-bottom',
// });

const specifications = [
  {
    title: "Global Certiport Accreditations",
    description:
      "As an official Certiport partner, we enable developers to sit for industry-standard certification exams remotely. Validate your expertise in cloud infrastructures, systems programming, and modern dev tools, earning globally recognized credentials to stand out in elite technical cohorts.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
        <circle cx="12" cy="8" r="6" />
      </svg>
    ),
  },
  {
    title: "AI-Powered Microlearning & Lectures",
    description:
      "Navigate our vast archive of self-paced video lessons indexed with deep tags. Dive straight into sandbox coding segments, cloud architecture schematics, and repository blueprints, making learning self-directed, flexible, and completely friction-free.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="m16 13 5.223 3.482a.5.5 0 0 0 .777-.416V7.87a.5.5 0 0 0-.752-.432L16 10.5" />
        <rect x="2" y="6" width="14" height="12" rx="2" />
      </svg>
    ),
  },
  {
    title: "Immutable Knowledge Repository",
    description:
      "Every single cohort stream and lecture is archived and committed to our permanent, lifetime-access database. Revisit production setup guides, system configurations, and code review records months or years down the line, ensuring a perpetual reference base.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="12" r="10" />
        <polyline points="12 6 12 12 16 14" />
      </svg>
    ),
  },
  {
    title: "Live Collaborative Debug Cohorts",
    description:
      "Engage in interactive virtual hackathons and live coding sessions facilitated by elite engineers. Participate in live terminal share, peer-to-peer code reviews, and architectural whiteboarding, simulating the workflows of remote engineering squads.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    title: "Elite Systems Mentorship",
    description:
      "Our instructors are certified software architects and active industry leaders with years of production deployment experience. Get direct mentorship on microservice patterns, infrastructure management, and technical leadership strategies.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z" />
      </svg>
    ),
  },
  {
    title: "Tailored Architectural Pathing",
    description:
      "We design personal roadmaps to accommodate your technical background. Receive personalized roadmap guidance, mock coding interview feedback, and 1-on-1 architecture reviews with dedicated technical leads.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M12 7v14" />
        <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
      </svg>
    ),
  },
  {
    title: "Production-Grade Sandbox Labs",
    description:
      "Our coursework prioritizes real-world output. Build high-concurrency APIs, deploy isolated container ecosystems, and write test suites. Master the tools and workflows used to run operations at massive scale.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M20 16V7a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v9m16 0H4m16 0 1.28 2.55a1 1 0 0 1-.9 1.45H3.62a1 1 0 0 1-.9-1.45L4 16" />
      </svg>
    ),
  },
  {
    title: "Hyper-Accessible Cyber Infrastructure",
    description:
      "Access cutting-edge system design and programming education without high costs. Our pricing structures are engineered to deliver maximum enterprise-grade learning value for every technical cohort.",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <rect width="20" height="14" x="2" y="5" rx="2" />
        <line x1="2" x2="22" y1="10" y2="10" />
      </svg>
    ),
  },
  {
    title: "Open-Access Foundational Blueprints",
    description:
      "We believe that distributing open-access code blueprints and system design templates is crucial to foster a global, collaborative, and highly capable developer community.",
    icon: (
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <rect x="4" y="2" width="16" height="20" rx="2" ry="2" />
        <line x1="8" y1="6" x2="16" y2="6" />
        <line x1="8" y1="10" x2="16" y2="10" />
        <line x1="8" y1="14" x2="13" y2="14" />
      </svg>
    ),
  },
];

const statsData = [
  {
    label: "Active Engineers",
    value: "2,500+",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M22 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    label: "Global Credentials",
    value: "15+",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526" />
        <circle cx="12" cy="8" r="6" />
      </svg>
    ),
  },
  {
    label: "Sandbox Tracks",
    value: "50+",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <path d="M12 7v14" />
        <path d="M3 18a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h5a4 4 0 0 1 4 4 4 4 0 0 1 4-4h5a1 1 0 0 1 1 1v13a1 1 0 0 1-1 1h-6a3 3 0 0 0-3 3 3 3 0 0 0-3-3z" />
      </svg>
    ),
  },
  {
    label: "Alumni Placement",
    value: "98%",
    icon: (
      <svg viewBox="0 0 24 24" fill="none" stroke="currentColor">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 2a14.5 14.5 0 0 0 0 20 14.5 14.5 0 0 0 0-20" />
        <path d="M2 12h20" />
      </svg>
    ),
  },
];

const features = [
  "Production-ready DevOps and architecture labs",
  "Certiport accredited learning pathways",
  "24/7 Sandbox execution & workspace access",
  "Lifetime repository and resource compilation updates",
];

const avatars = [
  "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  "https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
];

const testimonials = [
  {
    id: 1,
    content:
      "Digital Academy completely upgraded my technical trajectory. The Cloud Architecture path and Certiport certifications enabled me to secure a Lead DevOps Engineer role with a 30% compensation bump. The live debug sessions were a game changer.",
    author: "Samantha Lee",
    position: "Lead DevOps Engineer",
    company: "NexaCloud Systems",
    image:
      "https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    id: 2,
    content:
      "Learning dynamic backend systems while holding a full-time position was only possible due to their asynchronous sandbox tracks. The live mentor review sessions on system design helped me transition to a Full-Stack Engineer role within months.",
    author: "Michael Rodriguez",
    position: "Full-Stack Engineer",
    company: "QuantumTech Systems",
    image:
      "https://images.unsplash.com/photo-1500648767791-00dcc994a43e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    id: 3,
    content:
      "Coming from a non-CS background, I was intimidated by systems programming. The interactive cohorts broke down complex containerization and microservices into modular steps. I'm now confidently deploying high-scale APIs.",
    author: "Priya Patel",
    position: "Systems Architect",
    company: "SynthData Labs",
    image:
      "https://images.unsplash.com/photo-1548142813-c348350df52b?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
  {
    id: 4,
    content:
      "Taking proctored Certiport exams from home through their platform was incredibly smooth. The preparation mock labs were highly aligned with live production challenges. It gave my resume the ultimate system-level edge.",
    author: "David Chen",
    position: "Infrastructure Specialist",
    company: "Global Financial Services",
    image:
      "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80",
  },
];

const Landing = () => {
  const carouselRef = useRef(null);
  const [courses, setCourses] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 1150);
  const [isPromoOpen, setIsPromoOpen] = useState(false);
  const [promoCourses, setPromoCourses] = useState([]);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 1150);
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const showDrawer = () => setDrawerVisible(true);
  const closeDrawer = () => setDrawerVisible(false);



  useEffect(() => {
    AOS.init({
      disable: false,
      startEvent: "DOMContentLoaded",
      initClassName: "aos-init",
      animatedClassName: "aos-animate",
      useClassNames: false,
      disableMutationObserver: false,
      debounceDelay: 50,
      throttleDelay: 99,
      offset: 120,
      delay: 0,
      duration: 500,
      easing: "ease",
      once: false,
      mirror: false,
      anchorPlacement: "top-bottom",
    });

    // Refresh AOS after content loads
    const timer = setTimeout(() => {
      AOS.refresh();
    }, 1000);

    return () => clearTimeout(timer);
  }, []);

  const scrollToSection = (id) => {
    const el = document.getElementById(id);
    if (!el) return;

    // measure header height (plus optional extra gap)
    const header = document.querySelector("header");
    const headerOffset = header ? header.clientHeight + 16 : 0; // +16px breathing room

    // find element's absolute position
    const elementY = el.getBoundingClientRect().top + window.pageYOffset;

    // scroll so element sits just below header
    window.scrollTo({
      top: elementY - headerOffset,
      behavior: "smooth",
    });

    if (isMobile) closeDrawer();
  };

  useEffect(() => {
    handleGetHomeCourses();
  }, []);

  const handleGetHomeCourses = async () => {
    setIsLoading(true);
    try {
      const response = await getHomeCourses();
      const sortedResponse = response.sort(
        (a, b) => a?.orderNumber - b?.orderNumber
      );
      setCourses(sortedResponse);

      const advertised = sortedResponse.filter(item => {
        if (!item?.tags) return false;
        const tagList = item.tags.split(',').map(t => t.trim());
        return tagList.includes('Advertise');
      });
      setPromoCourses(advertised);

      if (advertised.length > 0 && sessionStorage.getItem('dismissedPromo') !== 'true') {
        setTimeout(() => {
          setIsPromoOpen(true);
        }, 1200);
      }
    } catch (error) {
      console.error(error);
    }
    setIsLoading(false);
  };

  const handleClosePromo = () => {
    setIsPromoOpen(false);
    sessionStorage.setItem('dismissedPromo', 'true');
  };
  return (
    <div className="landing-page" id="landinghome">
      <header className="site-header">
        <div className="header-conteiner">
          {/* logo */}
          <div className="logo">
            <a href="/" aria-label="Digital Academy Home">
              <img src={logo} alt="Digital Academy Logo" />
            </a>
          </div>

          {/* hamburger icon, mobile only */}
          {isMobile && (
            <Button
              type="text"
              className="mobile-menu-icon"
              onClick={showDrawer}
              aria-label="Open Menu"
              icon={<MenuOutlined />}
            />
          )}

          {/* desktop navigation */}
          <div className="btns">
            <Button type="link" onClick={() => scrollToSection("courses")}>
              Courses
            </Button>
            <Button
              type="link"
              onClick={() => scrollToSection("features-heading")}
            >
              About Us
            </Button>
            <Button type="link" onClick={() => scrollToSection("footer")}>
              Contact
            </Button>
            <Link className="register-btn" to="/register">
              Student Registration
            </Link>
            <Link className="signin-btn" to="/login">
              Sign In
            </Link>
          </div>
        </div>

        {/* mobile drawer */}
        {isMobile && (
          <Drawer
            placement="right"
            closable={true}
            onClose={closeDrawer}
            visible={drawerVisible}
            closeIcon={<CloseOutlined />}
            className="mobile-menu-drawer"
            width={280}
          >
            {/* <div className="drawer-logo">
            <img className='drawer-img' src={logo} alt="Digital Academy Logo" />
          </div> */}

            <div className="drawer-menu">
              <Button
                block
                type="link"
                onClick={() => scrollToSection("courses")}
              >
                <span>Courses</span>
                <RightOutlined />
              </Button>
              <Button
                block
                type="link"
                onClick={() => scrollToSection("features-heading")}
              >
                <span>About Us</span>
                <RightOutlined />
              </Button>
              <Button
                block
                type="link"
                onClick={() => scrollToSection("footer")}
              >
                <span>Contact</span>
                <RightOutlined />
              </Button>
              <Link to="/register">
                <Button block type="link">
                  <span>Student Registration</span>
                  <RightOutlined />
                </Button>
              </Link>
            </div>

            <div className="drawer-footer">
              <Link to="/login">
                <Button block type="primary" size="large">
                  Sign In
                </Button>
              </Link>
            </div>
          </Drawer>
        )}
      </header>

      <div className="body">

        <section
          className="hero"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          data-aos-easing="ease-out-cubic"
        >
          {/* Dot-grid overlay */}
          <div className="hero-grid-overlay" />


          <div className="content">
            <h2>Welcome to</h2>
            <h1 className="gradient-text">Digital Academy</h1>
            <p>"Empowering the next generation of tech leaders."</p>

            <div className="buttons">
              <Link className="hero-cta-button" to="/dashboard/cources">
                Explore Courses
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    d="m9 18 6-6-6-6"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                  />
                </svg>
              </Link>

              <Link className="hero-secondary-button" to="/register">
                Register Now
              </Link>
            </div>
            <div className="hero-stats">
              <div className="stats-container">
                <div className="avatar-group">
                  {avatars.map((src, idx) => (
                    <img
                      key={idx}
                      src={src}
                      alt={`Student ${idx + 1}`}
                      className="avatar"
                    />
                  ))}
                </div>
                <div className="stats-text">
                  <p className="stats-title">Join 2,500+ developers</p>
                  <div className="stats-rating">
                    {[...Array(5)].map((_, i) => (
                      <svg
                        key={i}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                        className="star"
                      >
                        <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
                      </svg>
                    ))}
                    <span className="rating-text">
                      4.9/5 from 1,200+ reviews
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="image">
            <div className="image-bg-circle" />
            <img src={heroImage} alt="hero" />
          </div>
        </section>
        <section
          className="carousel-section"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <Carousel autoplay>
            <div>
              <img src={image1} alt="carousel 1" />
            </div>
            <div>
              <img src={image2} alt="carousel2" />
            </div>
            <div>
              <img src={image3} alt="carousel3" />
            </div>
            <div>
              <img src={image4} alt="carousel4" />
            </div>
          </Carousel>
        </section>

        <section className="stats-section">
          <div className="stats-grid">
            <div className="stat-item">
              <div className="stat-number">2,500+</div>
              <div className="stat-label">Active Students</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">15+</div>
              <div className="stat-label">Certifications</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">50+</div>
              <div className="stat-label">Online Courses</div>
            </div>
            <div className="stat-item">
              <div className="stat-number">98%</div>
              <div className="stat-label">Satisfaction</div>
            </div>
          </div>
        </section>

        <section className="features-section" id="features-heading">
          <div className="features-header">
            <h2>Why Choose <span className="gradient-text">Digital Academy?</span></h2>
          </div>
          <div className="features-grid">
            {[
              { icon: 'school', title: 'Online Certification', text: 'We are an official Certiport partner, providing students globally recognized certification exams in digital literacy and business productivity.', color: 'primary' },
              { icon: 'play_circle', title: 'Self-paced Tutorials', text: 'Access our extensive library of video tutorials at your own convenience, allowing for a pressure-free learning environment tailored to your speed.', color: 'cyan' },
              { icon: 'timer', title: 'Lifetime Access', text: 'Recorded classes are available for a lifetime, enabling students to revisit complex topics whenever needed to reinforce their knowledge.', color: 'purple' },
              { icon: 'groups', title: 'Live Interactive Classes', text: 'Engage with instructors in real-time. Our virtual classrooms mimic physical ones, encouraging discussion and hands-on problem solving.', color: 'primary' },
              { icon: 'workspace_premium', title: 'Expert Instructors', text: 'Learn from industry veterans with years of experience who ensure you receive top-tier guidance to pass your certification exams.', color: 'green' },
              { icon: 'support_agent', title: 'Personalized Support', text: 'We provide one-on-one sessions and dedicated mentors for students who need extra help, ensuring nobody is left behind in their journey.', color: 'yellow' },
            ].map((feature, idx) => (
              <div className="feature-card glass-card" key={idx}>
                <div className={`feature-icon-wrapper color-${feature.color}`}>
                  <span className="material-symbols-outlined">{feature.icon}</span>
                </div>
                <h3>{feature.title}</h3>
                <p>{feature.text}</p>
              </div>
            ))}
          </div>
        </section>

        <section
          id="courses"
          className="courses"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <div className="featured-courses">
            <h2>
              Explore <span className="gradient-text">Active Engineering Tracks</span>
            </h2>
            <p className="para">
              Master full-stack programming, cloud architecture, and data engineering through our production-grade cohorts.
            </p>
          </div>
          {/* <h1>
            Our Courses
          </h1> */}

          <div className="cources-body">
            <Spin tip="Loading..." spinning={isLoading}>
              {courses && courses.length > 0 ? (
                <div className="bento-courses-grid">
                  {courses.filter(item => item.type !== 'book').map((item, idx) => (
                    <div className="glass-card course-card" key={idx}>
                      <div className="card-image-container">
                        <img
                          src={item?.coverImage ? item?.coverImage : DEFAULT_COURSE_COVER_IMAGE}
                          className="bg-blur"
                          alt=""
                        />
                        <img
                          src={item?.coverImage ? item?.coverImage : DEFAULT_COURSE_COVER_IMAGE}
                          className="main-img"
                          alt={item?.name}
                        />
                      </div>
                      <div className="card-content-wrapper">
                        <div className="card-header-row">
                          <h3 className="title line-clamp-2">{item?.name}</h3>
                          <span className="price">
                            {Number(item?.price) === 0 ? 'FREE' : `${item?.price} LKR`}
                          </span>
                        </div>
                        {item?.description ? (
                          <div
                            className="description"
                            dangerouslySetInnerHTML={{ __html: item?.description }}
                          />
                        ) : (
                          <p className="description">
                            Master this subject with our comprehensive curriculum and earn global recognition.
                          </p>
                        )}
                        <div className="card-actions-row">
                          <Link className="view-btn flex-1" to={`/dashboard/cources/${item?.id}`}>
                            View Details
                          </Link>
                          {item?.whatsappGroupLink && (
                             <a href={item?.whatsappGroupLink} target="_blank" rel="noreferrer" className="whatsapp-btn">
                               <WhatsAppOutlined />
                             </a>
                           )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="no-courcesdiv">No courses available</div>
              )}
            </Spin>
            <div className="view-all-container">
               <button className="accent-btn-gradient">View All Courses</button>
            </div>
          </div>
        </section>

        {courses && courses.some(item => item.type === 'book') && (
          <section className="ebooks-section bg-surface-container-low" id="ebooks">
            <div className="ebooks-header flex justify-between items-end">
              <div>
                <h2>Premium <span className="gradient-text">eBooks Library</span></h2>
                <p>Deepen your knowledge with our high-quality digital guides on AI and Productivity.</p>
              </div>
            </div>
            <Spin tip="Loading..." spinning={isLoading}>
              <div className="bento-ebooks-grid mt-8">
                {courses.filter(item => item.type === 'book').map((item, idx) => (
                  <div className="glass-card ebook-card flex gap-6" key={idx}>
                    <div className="ebook-image-container">
                      <img
                        src={item?.coverImage ? item?.coverImage : DEFAULT_COURSE_COVER_IMAGE}
                        className="bg-blur"
                        alt=""
                      />
                      <img
                        src={item?.coverImage ? item?.coverImage : DEFAULT_COURSE_COVER_IMAGE}
                        className="main-img"
                        alt={item?.name}
                      />
                    </div>
                    <div className="ebook-content">
                      <h3 className="title">{item?.name}</h3>
                      {item?.description ? (
                        <div
                          className="description"
                          dangerouslySetInnerHTML={{ __html: item?.description }}
                        />
                      ) : (
                        <p className="description">The definitive guide to master these topics.</p>
                      )}
                      <div className="ebook-actions flex gap-4 items-center">
                        <span className="price font-bold">
                          {Number(item?.price) === 0 ? 'FREE' : `${item?.price} LKR`}
                        </span>
                        <Link to={`/dashboard/cources/${item?.id}`} className="buy-now-btn">
                          Buy Now
                        </Link>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </Spin>
          </section>
        )}
      </div>

      <section className="testimonials-section">
        <div
          className="container"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <h2 className="testimonials-title">
            What Our <span className="gradient-text">Students Say</span>
          </h2>
          <p className="testimonials-subtitle">
            Don't just take our word for it. Hear what our students have
            achieved with Digital Academy.
          </p>

          <div className="testimonial-carousel-wrapper">
            {/* Prev button */}
            <button
              className="arrow-btn prev-btn"
              onClick={() => carouselRef.current.prev()}
            >
              <LeftOutlined />
            </button>

            <Carousel
              ref={carouselRef}
              autoplay
              speed={1000}
              autoplaySpeed={5000}
            >
              {testimonials.map((t, idx) => (
                <div key={idx}>
                  <div className="glass-card testimonial-card max-w-4xl mx-auto rounded-3xl p-12 relative">
                    <span className="material-symbols-outlined quote-icon text-[64px] absolute top-8 left-8 opacity-10 text-primary">format_quote</span>
                    <div className="relative z-10 text-center space-y-8">
                       <p className="text-body-lg italic leading-relaxed testimonial-text">
                        "{t.quote || t.content}"
                      </p>
                      <div className="flex flex-col items-center gap-4 mt-8">
                        <div className="w-20 h-20 rounded-full border-4 border-primary/20 p-1">
                          <img
                            src={t.image || t.avatar}
                            alt={t.author}
                            className="w-full h-full rounded-full object-cover"
                          />
                        </div>
                        <div>
                          <h4 className="font-headline-md author-name">{t.author}</h4>
                          <p className="text-on-surface-variant author-role">{t.position}, {t.company}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </Carousel>

            {/* Next button */}
            <button
              className="arrow-btn next-btn"
              onClick={() => carouselRef.current.next()}
            >
              <RightOutlined />
            </button>
          </div>
        </div>
      </section>

      <section className="cta-section py-section-gap-lg px-margin-desktop">
        <div
          className="max-w-container-max mx-auto bg-inverse-surface rounded-[40px] p-12 md:p-24 relative overflow-hidden text-center text-white"
          data-aos="fade-up"
          data-aos-duration="800"
          data-aos-offset="100"
          onLoad={() => AOS.refresh()}
        >
          <div className="relative z-10 space-y-8">
            <h2 className="font-display-lg text-display-lg-mobile md:text-display-lg cta-heading">Ready to Advance Your Career?</h2>
            <p className="text-body-lg text-white/70 max-w-2xl mx-auto">
              Join thousands of students who have already enhanced their professional skills and boosted their careers with Digital Academy. Start your learning journey today.
            </p>
            <div className="flex flex-wrap justify-center gap-6 pt-4 mt-8 cta-buttons-wrapper">
              <Link className="accent-btn-gradient text-white px-12 py-5 rounded-2xl shadow-2xl transition-all font-bold cta-btn-primary" to="/register">
                Enroll Now
              </Link>
              <Link className="bg-white/10 backdrop-blur-md border border-white/20 text-white px-12 py-5 rounded-2xl hover:bg-white/20 transition-all font-bold cta-btn-secondary" to="/dashboard/cources">
                Browse Courses
              </Link>
            </div>
          </div>
        </div>
      </section>

      <footer id="footer">
        <div className="footer-sec">
          <div className="logo">
            <a href="/">
              <img src={logo} alt="logo" />
            </a>
          </div>
          <div className="text">
            <p>
              A leading hybrid academy empowering developers globally. We deliver
              high-impact, industry-grade training and official Certiport pathings,
              leveraging cutting-edge cloud infrastructure and enterprise development tools.
            </p>
          </div>
        </div>

        <div className="footer-sec">
          <h3>Contacts</h3>
          <div className="text">
            <p>
              <span>
                <EnvironmentTwoTone />
              </span>
              634/A/8, Nugedeniya Rd, Thalangama South, Battaramulla. Sri Lanka.
            </p>
            <p>
              <span>
                <PhoneTwoTone />
              </span>
              +94-77 4747 920
            </p>
            <p>
              <span>
                <MailTwoTone />
              </span>
              <a href="/">info@digitalacademy.lk</a>
            </p>
          </div>
        </div>
      </footer>

      <section className="copy-right">
        <p>
          © 2026 Digital Academy. All RIghts Reserved.
        </p>

        <p>
          Designed & Developed by LionBit Solutions PVT LTD
        </p>
      </section>

      {isPromoOpen && promoCourses.length > 0 && (
        <div className="promo-overlay" onClick={handleClosePromo}>
          <div className="promo-modal" onClick={(e) => e.stopPropagation()}>
            <button className="promo-close-btn" onClick={handleClosePromo} aria-label="Close Ad">
              <CloseOutlined />
            </button>

            <div className="promo-badge">
              <span className="sparkle-icon">✨</span>
              SPECIAL ANNOUNCEMENT
            </div>

            {promoCourses.length === 1 ? (
              <div className="promo-single-layout">
                <div className="promo-image-sec">
                  <img src={promoCourses[0].coverImage || DEFAULT_COURSE_COVER_IMAGE} className="bg-blur" alt="" />
                  <img src={promoCourses[0].coverImage || DEFAULT_COURSE_COVER_IMAGE} className="main-img" alt={promoCourses[0].name} />
                </div>
                <div className="promo-details-sec">
                  <h3 className="promo-title">{promoCourses[0].name}</h3>
                  <div
                    className="promo-description"
                    dangerouslySetInnerHTML={{
                      __html: promoCourses[0].description || 'Learn and grow with our special course.'
                    }}
                  />
                  <div className="promo-price-tag">
                    {Number(promoCourses[0].price) === 0 ? (
                      <span className="free-badge">FREE</span>
                    ) : (
                      <span className="price-val">{promoCourses[0].price} LKR</span>
                    )}
                  </div>
                  <div className="promo-actions">
                    <Link
                      to={`/dashboard/cources/${promoCourses[0].id}`}
                      className="promo-cta-btn"
                      onClick={handleClosePromo}
                    >
                      Enrol Now
                    </Link>
                    <button className="promo-dismiss-btn" onClick={handleClosePromo}>
                      Maybe Later
                    </button>
                  </div>
                </div>
              </div>
            ) : (
              <div className="promo-carousel-layout">
                <Carousel autoplay dots effect="fade" speed={800} arrows={false}>
                  {promoCourses.map((course) => (
                    <div key={course.id} className="promo-slide">
                      <div className="promo-slide-grid">
                        <div className="promo-image-sec">
                          <img src={course.coverImage || DEFAULT_COURSE_COVER_IMAGE} className="bg-blur" alt="" />
                          <img src={course.coverImage || DEFAULT_COURSE_COVER_IMAGE} className="main-img" alt={course.name} />
                        </div>
                        <div className="promo-details-sec">
                          <h3 className="promo-title">{course.name}</h3>
                          <div
                            className="promo-description"
                            dangerouslySetInnerHTML={{
                              __html: course.description || 'Special training offer.'
                            }}
                          />
                          <div className="promo-price-tag">
                            {Number(course.price) === 0 ? (
                              <span className="free-badge">FREE</span>
                            ) : (
                              <span className="price-val">{course.price} LKR</span>
                            )}
                          </div>
                          <div className="promo-actions">
                            <Link
                              to={`/dashboard/cources/${course.id}`}
                              className="promo-cta-btn"
                              onClick={handleClosePromo}
                            >
                              Enrol Now
                            </Link>
                            <button className="promo-dismiss-btn" onClick={handleClosePromo}>
                              Maybe Later
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  ))}
                </Carousel>
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Landing;
